import React from 'react';
import './SpecificationsSection.css';

const SpecificationsSection = () => {
  const specifications = [
    'Ground Floor + basement (2,491sq.ft.) with landscaped lawn.',
    'First / Second Floor (1,394 sq.ft.).',
    'Second Floor with landscaped terrace lawn.',
    'Almirahs in all Bedrooms.',
    'Air-conditioned floors with 6 KVA power back.',
    'Fully furnished modular kitchen with Chimney & Hobb.',
    'Sensor controlled lighting system.',
    '6 KVA genset power backup.',
    'Security systems with video phones and burglar alarm.',
    'Video phones on main door & sensor lights in living room.'
  ];

  const highlights = [
    'In vicinity of three life-size theme parks.',
    'Bathrooms fitted with geysers, exhaust & glass partition.',
    'Situated on Golf Course Extension Road.',
    'Close to the proposed Metro corridor.',
    'Well connected to NH-8 and Golf Course Road.',
    'Excellent connectivity to Gurgaon-NCR via upcoming metro.',
    'Proximity to residential, retail and commercial development on Sohna road.',
    'World class schools within ~20 minutes: Shikshantar, DPS, Amity, Pathways, GD Goenka.',
    'Leading hospitals within ~20 minutes: Medicity, Artemis, Max, Fortis, Apollo.'
  ];

  return (
    <section className="specifications-section" id="amenities">
      <div className="container">
        <div className="specifications-layout">
          {/* Left Content */}
          <div className="specifications-content">
            {/* Specifications */}
            <div className="specs-block">
              <div className="specs-header">
                <h2 className="specs-title">
                  Ansal Esencia <span className="highlight">Specifications</span>
                </h2>
              </div>

              <div className="specs-list">
                <ul className="feature-list">
                  {specifications.map((spec, index) => (
                    <li key={index} className="feature-item">
                      <div className="feature-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </div>
                      <span className="feature-text">{spec}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Highlights */}
            <div className="highlights-block">
              <div className="highlights-header">
                <h2 className="highlights-title">
                  Ansal Esencia <span className="highlight">Highlights</span>
                </h2>
              </div>
              <div className="highlights-list">
                <ul className="feature-list">
                  {highlights.map((highlight, index) => (
                    <li key={index} className="feature-item">
                      <div className="feature-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </div>
                      <span className="feature-text">{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecificationsSection;